import axios from "./axios";
import { saveEvent } from "./userevents";
import { getItem } from "./../utils/persistanceStorage";

export const processSimpleActivity = (processObj) => {
  return axios.post("/processsimpleaccessmentactivity", processObj, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const processSpliceActivity = (processObj) => {
  return axios.post("/processspliceactivity", processObj, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const processAccessmentActivity = (processObj) => {
  return axios.post("/processaccessmentactivity", processObj, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const answerOnboardingQuestion = (activityid, answer) => {
  const userdata = getItem("user-data");
  const payload = { activityid, answer, sessionid: userdata?.sessionid };
  console.info("[ONBOARDING] POST /answer", JSON.stringify(payload));

  return axios.post("/answer", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export const saveExercise = (processObj) => {
  return axios.post("/updateactivityanswer", processObj, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const saveAnswer = (processObj) => {
  return axios.post("/updateactivityanswer", processObj, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteAnswer = (processObj) => {
  return axios.post("/resetactivityanswer", processObj, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
